import {
	CreateBase,
	Form,
	Toolbar,
	useGetIdentity,
	useTranslate
} from 'react-admin';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { GoToListButton } from '../../../components';
import { ICONS_BY_OBJECT, OBJECTS_TYPES } from '../../../constants';
import { BuildingInputs } from '../BuildingInputs';

export const BuildingCreate = () => {
	const { identity } = useGetIdentity();
	const translate = useTranslate();

	const Icon = ICONS_BY_OBJECT[OBJECTS_TYPES.BUILDINGS];

	return (
		<Box mt={3}>
			<GoToListButton />
			<CreateBase
				resource={OBJECTS_TYPES.BUILDINGS}
				redirect={() => `objects/${OBJECTS_TYPES.BUILDINGS}`}
				transform={data => ({
					...data
				})}
			>
				<Box mt={2} display="flex">
					<Box flex="1">
						<Stack mb={1} direction="row" alignItems="center">
							<Icon fontSize="large" />
							<Typography ml={1} variant="h4">
								{translate('objects.items.building')}
							</Typography>
						</Stack>
						<Form defaultValues={{ sales_id: identity?.id }}>
							<Card>
								<CardContent>
									<BuildingInputs />
								</CardContent>
								<Toolbar />
							</Card>
						</Form>
					</Box>
				</Box>
			</CreateBase>
		</Box>
	);
};
